import styled from "@emotion/styled";
import Menu, { MenuProps } from "@mui/material/Menu";

const BaseMenu = (props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "left",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "left",
    }}
    autoFocus={false}
    disableAutoFocusItem={false}
    role="menu"
    disableScrollLock
    disableRestoreFocus={false}
    {...props}
  />
);

export const StyledMenu = styled(BaseMenu)`
  .MuiPaper-root {
    border-radius: 0.5px;
    margin-top: 8px;
    min-width: 100px;
    box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.15);
  }
`;
